__turbopack_context__.v({
  "blink": "Grid-module-scss-module__yMMXSa__blink",
  "columns1": "Grid-module-scss-module__yMMXSa__columns1",
  "columns2": "Grid-module-scss-module__yMMXSa__columns2",
  "columns3": "Grid-module-scss-module__yMMXSa__columns3",
  "image": "Grid-module-scss-module__yMMXSa__image",
  "projectsGrid": "Grid-module-scss-module__yMMXSa__projectsGrid",
  "projectsList": "Grid-module-scss-module__yMMXSa__projectsList",
  "threeColumn": "Grid-module-scss-module__yMMXSa__threeColumn",
});
